"use client";
import { Link } from "@/i18n/routing";
import { IconForwardArrowBlack } from "@repo/assets/images";
import { LogOutButton } from "@repo/components";
import { CMS_LINKS, FAVOURITE_LINK } from "@repo/constants/common";
import { useActivePath } from "@repo/lib/hooks/common";
import { useTrackAccountMenuClick } from "@repo/lib/hooks/webengage";
import cx from "classnames";
import { useTranslations } from "next-intl";
import React from "react";

const Items = React.memo(({ item, activePath }) => {
  const t = useTranslations("Common");
  const { trackAccountMenuClickEvent } = useTrackAccountMenuClick();
  const IconComponent = item.icon;
  const isActive = activePath === item.url;
  return (
    <li
      className={cx(
        "border-supportiveDarkGray hover:bg-icon-bg hover:text-supportiveBlack border-b",
        {
          "bg-icon-bg text-supportiveBlack": isActive,
          "text-supportiveGray4": !isActive,
        }
      )}
    >
      <Link
        href={item?.url}
        onClick={() => !isActive && trackAccountMenuClickEvent(item.name)}
        className="border-lightgray flex items-center whitespace-nowrap rounded border p-2 md:border-0 md:p-4"
      >
        <IconComponent
          className={cx("me-2 fill-current", {
            "text-icon-color": isActive,
          })}
        />
        <span className="font-medium">{t(item?.label)}</span>
        <IconForwardArrowBlack
          className={cx("ms-auto hidden fill-current md:block rtl:rotate-180", {
            "text-icon-color": isActive,
          })}
        />
      </Link>
    </li>
  );
});

Items.displayName = "Items";

const CmsMenu = ({ session }) => {
  const t = useTranslations("Common");
  const activePath = useActivePath();
  return (
    <div className="hidden md:block">
      {!session && (
        <>
          <h4 className="font-heading rtl:font-arabic py-4 text-xl font-medium md:text-2xl">
            {t("Products")}
          </h4>
          <ul className="border-supportiveDarkGray border border-b-0">
            {FAVOURITE_LINK?.map((item) => (
              <Items item={item} key={item.id} activePath={activePath} />
            ))}
          </ul>
        </>
      )}
      <h4 className="font-heading rtl:font-arabic py-4 text-xl font-medium md:text-2xl">
        {t("Policies_And_Support")}
      </h4>
      <ul className="border-supportiveDarkGray border border-b-0">
        {CMS_LINKS?.map((item) => (
          <Items item={item} key={item.id} activePath={activePath} />
        ))}
      </ul>
      {session && (
        <div className="border-supportiveDarkGray border-x border-b">
          <LogOutButton />
        </div>
      )}
    </div>
  );
};

export default CmsMenu;
